// extracted by mini-css-extract-plugin
export default {"competitonsContainer":"home_competitonsContainer__fqwKd"};